exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n    background-color:#EBEBEB;\n    padding-top: 5em;\n}\n* {\n    font-family: 'Raleway';\n}\nbutton {\n    background:#008FEF;\n    color:white;\n    padding: 1.2em;\n    width:300px;\n    text-align:center;\n    font-size:1.2em;\n    margin-bottom: 30px;\n    cursor:pointer;\n}\ncode {\n    display: block;\n    background: #333;\n    color: lightGreen;\n    padding: 2px 4px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/~/css-loader?{"sourceMap":false,"importLoaders":1}!/Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/~/postcss-loader?{"ident":"postcss"}!/Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2